(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({behavior: 'instant'});
      }
    }, {once: true});
  }

  document.addEventListener('DOMContentLoaded', () => {
    const toggleBtn = document.getElementById('collection-header-filter-toggle');
    if (! toggleBtn) return;
    


    toggleBtn.addEventListener('click', () => {
      const filterWrapper = document.querySelector('.facets-block-wrapper--horizontal');
      const collectionWrapper = document.querySelector('.collection-wrapper');
      const toggleText = toggleBtn.querySelector('.collection-header__toggle-text');
      if (! filterWrapper) return;
      


      const isHidden = collectionWrapper && collectionWrapper.classList.contains('collection-wrapper--filter-hidden');
      if (collectionWrapper) {
        collectionWrapper.classList.toggle('collection-wrapper--filter-hidden');
      }
      toggleText.textContent = isHidden
        ? 'Hide Filter'
        : 'Show Filter';
    });
  });

// Mobile filter drawer
  document.addEventListener('DOMContentLoaded', () => {
    const dialog = document.querySelector('#filters-drawer dialog.facets--drawer');
    if (! dialog) return;
    


// Ensure all details are open (overrides accordion-custom timing)
    function openAllDetails() {
      dialog.querySelectorAll('details').forEach(d => {
        d.open = true;
      });
    }

// Open drawer when the filter toggle button is clicked
    document.querySelectorAll('.facets-toggle__button').forEach(btn => {
      btn.addEventListener('click', () => {
        dialog.showModal();
        openAllDetails();

// Retry after a frame to catch any late accordion-custom resets
        requestAnimationFrame(openAllDetails);
      });
    });

// Animated close helper
    function closeDrawer() {
      dialog.classList.add('is-closing');
      dialog.addEventListener('animationend', () => {
        dialog.classList.remove('is-closing');
        dialog.close();
      }, {once: true});
    }

// Close drawer: backdrop, close button, or apply button
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog || e.target.closest('.facets-drawer__close') || e.target.closest('.facets__see-results')) {
        closeDrawer();
      }
    });

// Catch any accordion-custom re-closing after showModal
    new MutationObserver(() => {
      if (dialog.hasAttribute('open')) 
        openAllDetails();
      


    }).observe(dialog, {
      attributes: true,
      attributeFilter: ['open']
    });
  });

// AJAX filter update (replaces missing facets-form-component / facet-remove-component)
  document.addEventListener('DOMContentLoaded', () => {
    let currentFetch = null;

// Update each filter panel's clear button based on checked inputs
    function updateClearButtons() {
      document.querySelectorAll('.facets__item').forEach(function(item) {
        const clearEl = item.querySelector('.facets__clear');
        if (! clearEl) return;
        


        const hasChecked = item.querySelectorAll('input[type="checkbox"]:checked').length > 0;
        clearEl.classList.toggle('facets__clear--active', hasChecked);
      });
    }

// Immediately update the facets__status-wrapper bubble/label for a single filter item
    function updateFacetStatus(item) {
      const statusComp = item.querySelector('facet-status-component');
      if (! statusComp) return;
      


      const statusSpan = statusComp.querySelector('[ref="facetStatus"]');
      if (! statusSpan) return;
      


      const facetType = statusComp.getAttribute('facet-type');
      const checkedInputs = Array.from(item.querySelectorAll('input[type="checkbox"]:checked'));
      const count = checkedInputs.length;

      if (facetType === 'swatches') {
        if (count === 0) {
          statusSpan.innerHTML = '';
          statusSpan.classList.remove('bubble', 'facets__bubble');
        } else if (count <= 3) {
          statusSpan.innerHTML = '';
          statusSpan.classList.remove('bubble', 'facets__bubble');
          checkedInputs.forEach(function(input) {
            const swatch = input.parentElement && input.parentElement.querySelector('.swatch');
            if (swatch) 
              statusSpan.appendChild(swatch.cloneNode(true));
            


          });
        } else {
          statusSpan.innerHTML = String(count);
          statusSpan.classList.add('bubble', 'facets__bubble');
        }
      } else {
        if (count === 0) {
          statusSpan.textContent = '';
          statusSpan.className = '';
        } else if (count === 1) {
          const input = checkedInputs[0];
          let label = input.dataset.label || '';
          if (! label && input.id) {
            const lbl = item.querySelector('label[for="' + input.id + '"]');
            if (lbl) 
              label = lbl.textContent.trim();
            


          }
          if (! label) 
            label = input.value;
          


          statusSpan.textContent = label;
          statusSpan.className = '';
        } else {
          statusSpan.textContent = String(count);
          statusSpan.className = 'bubble facets__bubble';
        }
      }
    }

    function updateAllFacetStatuses() {
      document.querySelectorAll('.facets__item').forEach(updateFacetStatus);
    }

// Immediately update the facets__bubble count in the drawer title
    function updateDrawerBubble() {
      const drawerForm = document.querySelector('#filters-drawer form.facets__form');
      if (! drawerForm) return;
      


      const count = drawerForm.querySelectorAll('input[type="checkbox"]:checked').length;
      const title = document.querySelector('.facets-drawer__title');
      if (! title) return;
      


      let bubble = title.querySelector('.facets__bubble');
      if (count > 0) {
        if (! bubble) {
          bubble = document.createElement('span');
          bubble.className = 'bubble facets__bubble';
          bubble.setAttribute('aria-hidden', 'true');
          title.appendChild(bubble);
        }
        bubble.textContent = count;
      } else {
        if (bubble) 
          bubble.remove();
        


      }
    }

    function updateProducts(params) {
      if (currentFetch) 
        currentFetch.abort();
      


      const resultsList = document.querySelector('results-list[section-id]');
      const sectionId = resultsList && resultsList.getAttribute('section-id');
      if (! sectionId) {
        window.location.search = params.toString();
        return;
      }

      const searchStr = params.toString();
      const newUrl = window.location.pathname + (
        searchStr
          ? '?' + searchStr
          : ''
      );
      const sectionUrl = window.location.pathname + '?section_id=' + sectionId + (
        searchStr
          ? '&' + searchStr
          : ''
      );

      history.pushState({}, '', newUrl);

      const grid = document.querySelector('.main-collection-grid');
      if (grid) 
        grid.classList.add('facets-loading');
      


      const controller = new AbortController();
      currentFetch = controller;

      fetch(sectionUrl, {signal: controller.signal})
        .then(function(r) {
          return r.text();
        })
        .then(function(html) {
          const doc = new DOMParser().parseFromString(html, 'text/html');

  // Update product grid
          const newGrid = doc.querySelector('.main-collection-grid');
          if (newGrid && grid) 
            grid.innerHTML = newGrid.innerHTML;
          


  // Update result counts
          ['.facets-toggle__results-count', '.collection-header__count'].forEach(function(sel) {
            const cur = document.querySelector(sel);
            const upd = doc.querySelector(sel);
            if (cur && upd) 
              cur.textContent = upd.textContent;
            


          });

  // Update active filter pills
          document.querySelectorAll('.facets-remove').forEach(function(cur, i) {
            const all = doc.querySelectorAll('.facets-remove');
            if (all[i]) 
              cur.innerHTML = all[i].innerHTML;
            


          });

  // Update "See results" count in drawer
          const curSR = document.querySelector('#filters-drawer .facets__see-results');
          const newSR = doc.querySelector('#filters-drawer .facets__see-results');
          if (curSR && newSR) 
            curSR.innerHTML = newSR.innerHTML;
          


  // Sync Show More button with filtered results
          const curWrapper = document.querySelector('.show-more-wrapper');
          const newWrapper = doc.querySelector('.show-more-wrapper');
          if (newWrapper) {
            if (curWrapper) {
              curWrapper.dataset.nextUrl = newWrapper.dataset.nextUrl;
              const btn = curWrapper.querySelector('.show-more-btn');
              if (btn) {
                btn.disabled = false;
                btn.textContent = 'Show more';
              }
            } else {
              const grid = document.querySelector('.main-collection-grid');
              if (grid) 
                grid.after(newWrapper.cloneNode(true));
              


            }
          } else if (curWrapper) {
            curWrapper.remove();
          }

        })
        .catch(function(err) {
          if (err.name !== 'AbortError') 
            window.location.href = newUrl;
          


        })
        . finally(function() {
          if (grid) 
            grid.classList.remove('facets-loading');
          


          currentFetch = null;
          updateClearButtons();
          updateDrawerBubble();
        });
    }

// Desktop/sidebar: AJAX update on filter or sort change (300ms debounce)
// Use capture: true so this fires before facet-inputs-component can stop propagation
    document.addEventListener('change', function(e) {
      const form = e.target.form || e.target.closest('form.facets__form');
      if (! form || ! form.classList.contains('facets__form')) return;
      


      updateClearButtons(); // Update clear button visibility immediately on checkbox change
      updateDrawerBubble(); // Update drawer title bubble count immediately
      const changedItem = e.target.closest('.facets__item');
      if (changedItem) 
        updateFacetStatus(changedItem);
      


      if (form.closest('#filters-drawer')) return;
      


// Drawer uses Apply button
      clearTimeout(form._debounce);
      form._debounce = setTimeout(function() {
        updateProducts(new URLSearchParams(new FormData(form)));
      }, 300);
    }, true);

// Fallback: catch checkbox clicks in the drawer via click (fires even if change is swallowed)
    document.addEventListener('click', function(e) {
      if (e.target.type === 'checkbox' && e.target.closest('#filters-drawer')) {
        setTimeout(updateDrawerBubble, 0);
      }
    }, true);

// Drawer Apply button: AJAX update with drawer form params
// Filter remove pills / Clear All: AJAX update to their URL
// Per-filter Clear button: uncheck inputs in panel, then AJAX update (desktop only)
    document.addEventListener('click', function(e) {
      if (e.target.closest('#filters-drawer .facets__see-results')) {
        const drawerForm = document.querySelector('#filters-drawer form.facets__form');
        if (drawerForm) 
          updateProducts(new URLSearchParams(new FormData(drawerForm)));
        


        return;
      }
      const removeComp = e.target.closest('facet-remove-component[data-url]');
      if (removeComp) {
        e.preventDefault();
        const url = new URL(removeComp.dataset.url, window.location.href);
        updateProducts(new URLSearchParams(url.search));
        return;
      }
      const clearBtn = e.target.closest('.facets__clear--active');
      if (clearBtn) {
        e.preventDefault();
        const panel = clearBtn.closest('details.facets__panel') || clearBtn.closest('accordion-custom');
        if (panel) {
          panel.querySelectorAll('input:checked').forEach(function(input) {
            input.checked = false;
          });
        }
        updateClearButtons();
        updateDrawerBubble();
        if (panel) 
          updateFacetStatus(panel.closest('.facets__item') || panel);
        


// Drawer: just uncheck, user hits Apply to submit
        if (clearBtn.closest('#filters-drawer')) return;
        


        const form = clearBtn.closest('form.facets__form') || document.querySelector('form.facets__form');
        if (form) 
          updateProducts(new URLSearchParams(new FormData(form)));
        


      }
    });

// Show More button: append next page of products
    document.addEventListener('click', function(e) {
      const showMoreBtn = e.target.closest('.show-more-btn');
      if (! showMoreBtn || showMoreBtn.disabled) return;
      


      const wrapper = showMoreBtn.closest('.show-more-wrapper');
      const nextUrl = wrapper && wrapper.dataset.nextUrl;
      if (! nextUrl) return;
      


      showMoreBtn.disabled = true;
      showMoreBtn.textContent = 'Loading...';

      const resultsList = document.querySelector('results-list[section-id]');
      const sectionId = resultsList && resultsList.getAttribute('section-id');
      if (! sectionId) {
        showMoreBtn.disabled = false;
        showMoreBtn.textContent = 'Show more';
        return;
      }

      const fetchUrl = new URL(nextUrl, window.location.href);
      fetchUrl.searchParams.set('section_id', sectionId);

      fetch(fetchUrl.toString()).then(function(r) {
        return r.text();
      }).then(function(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newItems = doc.querySelectorAll('.product-grid__item');
        const productList = document.querySelector('.product-grid');

        if (productList && newItems.length) {
          newItems.forEach(function(item, i) {
            item.classList.add('product-grid__item--appearing');
            item.style.animationDelay = Math.min(i * 20, 200) + 'ms';
            productList.appendChild(item);
          });
        }

// Update or remove the Show More button based on next page availability
        const newWrapper = doc.querySelector('.show-more-wrapper');
        if (newWrapper && newWrapper.dataset.nextUrl) {
          wrapper.dataset.nextUrl = newWrapper.dataset.nextUrl;
          showMoreBtn.disabled = false;
          showMoreBtn.textContent = 'Show more';
        } else {
          wrapper.remove();
        }
      }).catch(function() {
        showMoreBtn.disabled = false;
        showMoreBtn.textContent = 'Show more';
      });
    });

// Back/forward: reload to restore correct filter state + checkbox UI
    window.addEventListener('popstate', function() {
      window.location.reload();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
